import { ReduxLoggerOptions, createLogger } from "redux-logger";

const loggerOptions: ReduxLoggerOptions = {
    timestamp: true,
};

const reduxLogger = createLogger(loggerOptions);

export default reduxLogger;
